import { useState } from "react";
import { Nav, Offcanvas, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "./Sidbar.css";
import { faMessage, faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullhorn,
  faCog,
  faTableCellsLarge,
  faHouse,
  faBars,
  faFileAlt,
  faPen,
  faChevronDown,
  faChevronUp,
  faGraduationCap,
  faBookBookmark,
  faCommentDots,
  faComments,
  faCoins,
  faMoneyBill,
  faTasks,
  faPercent,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Logout from "../../../Pages/Auth/Logout";
import { icon } from "@fortawesome/fontawesome-svg-core";
import { FaTasks } from "react-icons/fa";
import useAuth from "../../../Pages/hooks/useAuth";

export default function Sidebar() {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [showContentMenu, setShowContentMenu] = useState(false);
  const [showMessagesMenu, setShowMessagesMenu] = useState(false);
  const [showTestsMenu, setShowTestsMenu] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { auth } = useAuth();
  const adminEmails = ['admin@academy.com', 'admin@example.com'];
  let role = auth?.user?.role;
  const isExplicitAdmin = Boolean(
    auth?.user?.is_main_admin ||
    auth?.user?.is_admin ||
    role === 'admin' ||
    adminEmails.includes(auth?.user?.email)
  );

  if (isExplicitAdmin) {
    role = 'admin';
  } else if (!role || role === 'student') {
    role = auth?.user?.is_staff ? 'teacher' : 'student';
  }

  const isAdmin = role === 'admin';
  const isTeacher = role === 'teacher' && !isAdmin;

  const navLinksMain = [
    { to: "/DashboardLayout", icon: faTableCellsLarge, label: "لوحة التحكم" },
  ];

  const contentSubMenu = [
    {
      to: "/DashboardLayout/content/academic",
      icon: faGraduationCap,
      label: "المراحل الدراسية",
    },
    {
      to: "/DashboardLayout/content/months",
      icon: faBookBookmark,
      label: "الشهور الدراسية",
    },
    {
      to: "/DashboardLayout/content/lessons",
      icon: faFileAlt,
      label: "الدروس",
    },
    {
      to: "/DashboardLayout/content/assignments",
      icon: faTasks,
      label: "الواجبات المرسلة",
    },
  ];

  const testsSubMenu = [
    {
      to: "/DashboardLayout/tests/create-test",
      icon: faFileAlt,
      label: "إنشاء اختبار",
    },
    {
      to: "/DashboardLayout/tests/create-full-exam",
      icon: faFileAlt,
      label: "إنشاء امتحان كامل",
    },
    {
      to: "/DashboardLayout/tests/create-question",
      icon: faPen,
      label: "إنشاء أسئلة",
    },
  ];

  const messagesSubMenu = [
    {
      to: "/DashboardLayout/messages/student-queries",
      icon: faCommentDots,
      label: "استفسارات الطلاب",
    },
  ];

  const navLinksOther = [
    { to: "/DashboardLayout/teachers", icon: faGraduationCap, label: "إدارة المدرسين" },
    { to: "/DashboardLayout/teachers/add", icon: faPlus, label: "إضافة معلم" },
    {to: "/DashboardLayout/users", icon: faUser, label: "المستخدمين"},
    {to: "/DashboardLayout/money", icon: faMoneyBill, label: "التحويلات"},
    {to: "/DashboardLayout/monthly-summary", icon: faTableCellsLarge, label: "ملخص الشهر"},
    {to: "/DashboardLayout/discounts", icon: faPercent, label: "خصومات الكورسات"},
    {to: "/DashboardLayout/combos", icon: faCoins, label: "باقات الكورسات (الكومبو)"},
    {to: "/DashboardLayout/packages", icon: faBookBookmark, label: "باقات الترم والسنة"},
    {to: "/DashboardLayout/ads", icon: faBullhorn, label: "الإعلانات"},
    {to: "/DashboardLayout/taskDashbord", icon: faTasks, label: "المهام"},
    {to: "/DashboardLayout/settings", icon: faCog, label: "الإعدادات"},
    {to: "/DashboardLayout/landing-cards", icon: faTableCellsLarge, label: "عايز سنة كام؟"},
    {to: "/", icon: faHouse, label: "الصفحة الرئيسية"},
  ];

  const activeContentMenu = contentSubMenu.filter(item => {
    if (isTeacher && item.to.includes('/content/academic')) return false;
    return true;
  });

  const activeOtherLinks = navLinksOther.filter(item => {
    if (isTeacher) {
      return (
        item.to === "/" ||
        item.to === "/DashboardLayout/money" ||
        item.to === "/DashboardLayout/discounts"
      );
    }
    if ((item.to === "/DashboardLayout/teachers" || item.to === "/DashboardLayout/teachers/add" || item.to === "/DashboardLayout/landing-cards") && !isAdmin) {
      return false;
    }
    return true;
  });

  const renderNavLinks = (links) =>
    links.map((link, index) => (
      <Nav.Link
        key={index}
        as={Link}
        to={link.to}
        onClick={handleClose}
        className={location.pathname === link.to ? "active" : ""}
      >
        <FontAwesomeIcon
          style={{ marginLeft: "10px" }}
          icon={link.icon}
          className="me-2"
        />
        {link.label}
      </Nav.Link>
    ));

  const DropdownMenu = ({ label, icon, isOpen, toggle, items }) => (
    <>
      <div
        className="content-menu-toggle"
        onClick={toggle}
        style={{ cursor: "pointer", padding: "10px 15px" }}
      >
        <FontAwesomeIcon
          style={{ marginLeft: "5px" }}
          icon={icon}
          className="me-2"
        />
        {label}
        <FontAwesomeIcon
          icon={isOpen ? faChevronUp : faChevronDown}
          style={{ float: "left", marginLeft: "5px" }}
        />
      </div>
      {isOpen && (
        <div style={{ paddingRight: "20px" }}>{renderNavLinks(items)}</div>
      )}
    </>
  );

  return (
    <>
      {/* زر الموبايل */}
      <Button
        variant="light"
        onClick={handleShow}
        className="d-md-none m-3"
        style={{ position: "fixed", top: 10, right: 10, zIndex: 1001 }}
      >
        <FontAwesomeIcon icon={faBars} />
      </Button>

      {/* Sidebar Desktop */}
      <div className="sidebar d-none d-md-block" dir="rtl">
        <h4>الرئيسي</h4>
        <Nav className="flex-column mb-4">
          {renderNavLinks(navLinksMain)}
          <DropdownMenu
            label="المحتوى"
            icon={faPen}
            isOpen={showContentMenu}
            toggle={() => setShowContentMenu((p) => !p)}
            items={activeContentMenu}
          />
          <DropdownMenu
            label="الاختبارات"
            icon={faGraduationCap}
            isOpen={showTestsMenu}
            toggle={() => setShowTestsMenu((p) => !p)}
            items={testsSubMenu}
          />

          <DropdownMenu
            label="الرسائل"
            icon={faMessage}
            isOpen={showMessagesMenu}
            toggle={() => setShowMessagesMenu((p) => !p)}
            items={messagesSubMenu}
          />
          {renderNavLinks(activeOtherLinks)}
        </Nav>

        <Nav.Link as="span">
          <Logout />
        </Nav.Link>
      </div>

      {/* Sidebar Mobile */}
      {/* زر الموبايل */}
      {!show && (
        <Button
          variant="light"
          onClick={() => setShow(true)}
          className="d-md-none m-3"
          style={{ position: "fixed", top: 10, right: 10, zIndex: 1050 }}
        >
          <FontAwesomeIcon icon={faBars} />
        </Button>
      )}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        dir="rtl"
        className="sidebar" //1/ نفس الكلاس بتاع الديسكتوب
        style={{ width: "272px" }} //1/ عشان نضمن نفس العرض
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <h4 style={{ fontSize: "18px" }}>الرئيسي</h4>
          <Nav className="flex-column mb-3">
            {renderNavLinks(navLinksMain)}
            <DropdownMenu
              label="المحتوى"
              icon={faPen}
              isOpen={showContentMenu}
              toggle={() => setShowContentMenu((p) => !p)}
              items={activeContentMenu}
            />
            <DropdownMenu
              label="الاختبارات"
              icon={faGraduationCap}
              isOpen={showTestsMenu}
              toggle={() => setShowTestsMenu((p) => !p)}
              items={testsSubMenu}
            />

            <DropdownMenu
              label="الرسائل"
              icon={faMessage}
              isOpen={showMessagesMenu}
              toggle={() => setShowMessagesMenu((p) => !p)}
              items={messagesSubMenu}
            />
          </Nav>

          <h5 className="mt-4">أخرى</h5>
          <Nav className="flex-column">{renderNavLinks(activeOtherLinks)}</Nav>

          <div style={{ marginTop: "20px" }}>
            <Link style={{ fontSize: "18px", color: "#dc3545" }}>
              <Logout />
            </Link>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
